import CableReady from 'cable_ready';
import consumer from "./consumer";

consumer.subscriptions.create({channel: "StudioChannel", studio_id: window.studioId}, {
  received(data) {
    if (data.cableReady) {
      CableReady.perform(data.operations);
    }
  }
});